import type { APIHomeSection } from '~/api/commonApi'
import type { THomeSection, THomeSectionCollection } from '~/layers/homepage/data/types'
import { THomeSectionType } from '~/layers/homepage/data/types'
import { log } from '~/layers/homepage/data/logger'
import getPoster from '~/layers/homepage/data/getPoster'

export const make = (apiSection: APIHomeSection): (THomeSectionCollection & THomeSection) | null => {
  if (Array.isArray(apiSection.images)) {
    log(`Изображение блока ID ${apiSection.id} не установлено. Пропуск`, apiSection)
    return null
  }

  const items: THomeSectionCollection['items'] = []

  for (const apiSectionChild of apiSection.children) {
    if (Array.isArray(apiSectionChild.images)) {
      log(`Изображение дочернего элемента ID ${apiSectionChild.id} не установлено. Пропуск`, apiSectionChild)
      continue
    }

    items.push({
      picture: apiSectionChild.images,
      name: apiSectionChild.title,
      link: apiSectionChild.link,
    })
  }

  return {
    type: THomeSectionType.Collection,
    picture: apiSection.images,
    name: apiSection.title,
    pictureSquare: Array.isArray(apiSection.configuration)
      ? false
      : !!apiSection.configuration.isSquad,
    items: apiSection.children.map((c) => {
      return {
        name: c.title,
        picture: c.images,
        link: c.link,
      }
    }),
    link: apiSection.link,
    video: Array.isArray(apiSection.video)
      ? null
      : apiSection.video,
    poster: getPoster(apiSection),
  }
}
